import { BlurCutoutObject, Frame } from "../../types";
import { arrayToFrameValue } from "./array";
import { omit } from "lodash";

export const convertToFrame = (cutoutArray: BlurCutoutObject[]): Frame["blurCutoutShapes"] => {
  const filteredCutoutArray = cutoutArray.map((cutout) => omit(cutout, "isOpen", "type"));

  return arrayToFrameValue(filteredCutoutArray, "id") as Frame["blurCutoutShapes"];
};
